/**
 * 舞台颜色工具
 * 为每个舞台名稳定分配一个颜色，跨组件保持一致
 */

const STAGE_COLORS = [
  '#91caff', // 蓝
  '#ffadd2', // 粉
  '#b7eb8f', // 绿
  '#ffd591', // 橙
  '#d3adf7', // 紫
  '#87e8de', // 青
  '#ffa39e', // 红
  '#ffe58f', // 黄
];

// 按顺序分配缓存：第一次出现的舞台得到第一个颜色
let _colorCache = {};
let _colorIndex = 0;

/**
 * 根据舞台名称获取对应颜色（稳定，同一 session 内相同名称始终同色）
 */
export function getStageColor(stageName) {
  if (!_colorCache[stageName]) {
    _colorCache[stageName] = STAGE_COLORS[_colorIndex % STAGE_COLORS.length];
    _colorIndex++;
  }
  return _colorCache[stageName];
}

/**
 * 根据索引获取颜色
 */
export function getStageColorByIndex(index) {
  return STAGE_COLORS[index % STAGE_COLORS.length];
}

/**
 * 重置颜色缓存（切换 session 时调用，确保新 session 的舞台颜色从调色板开头分配）
 */
export function resetStageColors() {
  _colorCache = {};
  _colorIndex = 0;
}

/**
 * 将 hex 颜色转为带透明度的 rgba 字符串
 * @param {string} hex - '#91caff'
 * @param {number} alpha - 0~1
 */
export function hexToRgba(hex, alpha = 1) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r},${g},${b},${alpha})`;
}

export { STAGE_COLORS };
